import React, { FunctionComponent } from 'react';
import { makeStyles } from '@mui/styles';
import { Drawer, closeDrawer, useGlobalization } from '@innovyze/stylovyze';
import { useDispatch } from 'react-redux';

export enum HELP_DRAWER {
	DECISION_TREES_OVERVIEW = 'decisionTreesOverviewHelp',
}

export const getHelpURL = (type: HELP_DRAWER): string => {
	switch (type) {
		case HELP_DRAWER.DECISION_TREES_OVERVIEW:
			return 'https://help.autodesk.com/view/INF360A/ENU/?guid=GUID-BCD6FB57-09DD-4D99-89C5-64F911E5B562';
		default: {
			const exhaustiveCheck: never = type;
			throw new Error(`Unsupported help drawer type: ${exhaustiveCheck}`);
		}
	}
};

interface HelpDrawerProps {
	drawerID: HELP_DRAWER;
	onClose?: () => void;
}

const useStyles = makeStyles({
	drawer: {
		width: '34.5rem',
		zIndex: 1300,
		inset: 'unset',
	},
	iFrame: {
		height: 'calc(100% - 4px)',
		width: '100%',
	},
});

const HelpPageDrawer: FunctionComponent<HelpDrawerProps> = ({
	drawerID,
	onClose,
}) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { t } = useGlobalization();

	const close = (): void => {
		dispatch(closeDrawer());
		onClose?.();
	};

	return (
		<Drawer
			drawerId={drawerID}
			onClose={close}
			className={classes.drawer}
			hideBackdrop
			disableEnforceFocus
			padContent={false}
			action={{
				label: t('Close'),
				onClick: close,
			}}>
			<iframe
				src={getHelpURL(drawerID)}
				title="Help page"
				className={classes.iFrame}></iframe>
		</Drawer>
	);
};

export default HelpPageDrawer;
